export default "__VITE_ASSET__BWjaxKsB__"